var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.permissions.delete)?_c('v-icon',{attrs:{"small":"","color":"#D32F2F"},on:{"click":function($event){return _vm.deleteData(_vm.item)}}},[_vm._v("mdi-delete-outline")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }